/* eslint-disable react/jsx-no-undef */
import React, { Component } from "react";
import { Sidebar } from "../../Common";
import ChatWidget from "components/ChatWidget";
import NavbarActions from "../../Common/NavbarActions";
import { connect } from "react-redux";
import { auth } from "../../../services";
import "./index.css";
import SuperAdminRouteMaster from "../routeMaster";
import { Link,  } from 'react-router-dom';
import { withRouter } from 'utils/withRouter';
import { domainLevelConfig } from "../../../ui-config";
import { getPreferances, getSettings } from "../../../redux/actions";
import BigLoader from "../../Common/BigLoader";
import LiveChatIcon from "./LiveChatIcon";
import { compose } from "redux";
class SuperAdminLayout extends Component {
  state = {
    width: 0,
    widgetOpen: false,
  };

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    if (!this.props.initialyLoaded) {
      this.props.getPreferances(
        domainLevelConfig[this.props.host] || domainLevelConfig["default"] || {}
      );
      this.props.getSettings();
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth });
  };

  setWidgetOpen = (open) => {
    this.setState({ widgetOpen: open });
  };

  getUserDomain = () => {
    const email = this.props.currentUser?.email || "";
    return email.split("@")[1]?.toLowerCase() || "";
  };

  shouldShowChat = () => {
    const domain = this.getUserDomain();
    return ["secomind.ai", "studiox-ai.com"].includes(domain);
  };

  render() {
    const { width, widgetOpen } = this.state;
    const { fullscreen } = this.props;
    let newRoute = [...SuperAdminRouteMaster];
    const hostConfig =
      domainLevelConfig[this.props.host] || domainLevelConfig["default"] || {};

    SuperAdminRouteMaster.map((route, idx) => {
      if (auth.user.type == "SU") {
        if (route.path == "/secureId") {
          newRoute.splice(idx, 1);
        }
      }
    });

    if (!auth.user.type) {
      return null;
    }

    const paddingLeft = width > 768 ? (!fullscreen ? 72 : 212) : 72;

    return (
      <div
        style={{
          paddingLeft,
          paddingTop: fullscreen ? 0 : 0,
          position: "relative",
        }}
        id="superadmin-layout-wrapper"
      >
        {this.props.globalLoader && !this.props.initialyLoaded && (
          <BigLoader overlay={false} />
        )}
        {!this.props.globalLoader && this.props.initialyLoaded && (
          <>
            <NavbarActions />
            <div></div>
            <Sidebar routeMaster={newRoute} />
            <div
              style={
                SuperAdminRouteMaster.find(
                  (x) => x.path === this.props.location.pathname
                )?.background === false
                  ? { background: "none" }
                  : {}
              }
              className="content-wrapper"
            >
              {this.props.children}
            </div>
            {this.shouldShowChat() && (
              <div
                style={{
                  position: "fixed",
                  bottom: "3rem",
                  right: "2rem",
                  zIndex: 1000,
                  color: "black",
                }}
              >
                {!widgetOpen ? (
                  <div
                    style={{
                      position: "relative",
                      height: "6rem",
                      width: "6rem",
                    }}
                  >
                    <div
                      className="siri-wave siri-wave1"
                      style={{
                        position: "absolute",
                        inset: 0,
                        height: "100%",
                        width: "100%",
                        borderRadius: "50%",
                      }}
                    ></div>
                    <div
                      className="siri-wave siri-wave2"
                      style={{
                        position: "absolute",
                        inset: 0,
                        height: "100%",
                        width: "100%",
                        borderRadius: "50%",
                      }}
                    ></div>
                    <div
                      className="siri-wave siri-wave3"
                      style={{
                        position: "absolute",
                        inset: 0,
                        height: "100%",
                        width: "100%",
                        borderRadius: "50%",
                      }}
                    ></div>
                    <div
                      style={{
                        position: "absolute",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                        inset: 0,
                      }}
                      onClick={() => this.setWidgetOpen(true)}
                    >
                      <div
                        style={{
                          display: "flex",
                          height: "6rem",
                          width: "6rem",
                          alignItems: "center",
                          justifyContent: "center",
                          borderRadius: "50%",
                          backgroundColor: "black",
                          padding: "0.5rem",
                          textAlign: "center",
                          fontSize: "1rem",
                          fontWeight: "500",
                          lineHeight: "1.25rem",
                          color: "white",
                        }}
                      >
                        Live Chat
                      </div>
                    </div>
                  </div>
                ) : null}

                <ChatWidget
                  widgetOpen={widgetOpen}
                  iframeDomain={"https://dmvi.secomind.ai/bot/"}
                  setWidgetOpen={this.setWidgetOpen}
                />
              </div>
            )}
          </>
        )}

        <div
          className={`mt-2 d-flex align-items-center justify-content-between footer`}
          style={{ background: "#3A3A3C", width: "100vw" }}
        >
          <div>
            {hostConfig.aboutURL ? (
              <a
                href={hostConfig.aboutURL}
                className="login-links"
                style={{ color: "#FFFFFF", marginLeft: "2em" }}
                rel="noopener noreferrer"
                target="_blank"
              >
                About
              </a>
            ) : (
              <Link
                className="login-links"
                style={{ color: "#FFFFFF", marginLeft: "2em" }}
                to="/about"
              >
                About
              </Link>
            )}
            {hostConfig.helpCenterURL ? (
              <a
                href={hostConfig.helpCenterURL}
                className="login-links"
                style={{ color: "#FFFFFF", marginLeft: "2em" }}
                rel="noopener noreferrer"
                target="_blank"
              >
                Help Center
              </a>
            ) : null}
            {hostConfig.termsServiceURL ? (
              <a
                href={hostConfig.termsServiceURL}
                className="login-links"
                style={{ color: "#FFFFFF", marginLeft: "2em" }}
                rel="noopener noreferrer"
                target="_blank"
              >
                Terms of Service
              </a>
            ) : (
              <Link
                className="login-links"
                style={{ color: "#FFFFFF", marginLeft: "2em" }}
                to="/term"
              >
                Terms of Service
              </Link>
            )}
            {hostConfig.privacyPolicyURL ? (
              <a
                href={hostConfig.privacyPolicyURL}
                className="login-links"
                style={{ color: "#FFFFFF", marginLeft: "2em" }}
                rel="noopener noreferrer"
                target="_blank"
              >
                Privacy Policy
              </a>
            ) : (
              <Link
                className="login-links"
                style={{ color: "#FFFFFF", marginLeft: "2em" }}
                to="/policy"
              >
                Privacy Policy
              </Link>
            )}
            <Link
              className="login-links"
              style={{ color: "#FFFFFF", marginLeft: "2em" }}
              to="/version"
            >
              Version
            </Link>
          </div>

          <span style={{ color: "#FFFFFF" }}>
            © {new Date().getFullYear()} {hostConfig.name}
          </span>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    currentUser: state.userReducer.current_user,
    fullscreen: state.routeReducer.fullscreen,
    host: state.userReducer.host,
    theme: state.userReducer.theme,
    customTheme: state.userReducer.customTheme,
    globalLoader: state.userReducer.globalLoader,
    initialyLoaded: state.userReducer.initialyLoaded,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getPreferances: (hostConfig) => dispatch(getPreferances(hostConfig)),
    getSettings: () => dispatch(getSettings()),
  };
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withRouter
)(SuperAdminLayout);
